<template>
  <div>
    <div v-for="(uri, idx) in uris" :key="idx">
      <div v-for="(target, idx) in Object.keys(pages[uri])" :key="idx">
        <div v-if="targets[target]">
          <div class="i-css-oce-info-uri" :title="uri">
            <strong>{{ uri }}</strong>
          </div>
          <div class="i-css-oce-info-target-descr" :title="target">
            ( {{ targets[target].description }}:{{ target }} )
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    pages: Object,
    targets: Object,
  },
  computed: {
    uris() {
      if (!this.pages) return [];

      return Object.keys(this.pages);
    },
  },
  methods: {
  },
});
</script>

<style scoped lang='scss'>
.fa5 {
  right: 0px;
  float: right;
}
.fa-check-square {
  color:#26BF4B;
}
.fa-exclamation-circle {
  color: $red;
}
</style>
